var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / DeleteOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.7656 4.45312V3.95312V3.78125C14.7656 3.59964 14.6191 3.45312 14.4375 3.45312H14.2656H13.7656H7.73438H7.5625C7.38089 3.45312 7.23438 3.59964 7.23438 3.78125V3.95312V5H6.6875V3.78125C6.6875 3.29899 7.08024 2.90625 7.5625 2.90625H14.4375C14.9198 2.90625 15.3125 3.29899 15.3125 3.78125V5H14.7656V4.45312ZM7.73438 6H8.23438H13.7656H14.2656H15.8125H16.3125H18.5625C18.6666 6 18.75 6.08337 18.75 6.1875V6.54688H17.7805H17.3035L17.281 7.02329L16.7504 18.2596L16.7504 18.2598C16.7285 18.7279 16.3446 19.0938 15.877 19.0938H6.12305C5.65757 19.0938 5.27151 18.7258 5.24965 18.2598L5.24964 18.2596L4.71897 7.02329L4.69647 6.54688H4.21953H3.25V6.1875C3.25 6.08337 3.33337 6 3.4375 6H5.6875H6.1875H7.73438ZM15.7115 18.5469H16.1884L16.211 18.0705L16.7309 7.07048L16.7556 6.54688H16.2314H5.76855H5.24436L5.26911 7.07048L5.78903 18.0705L5.81155 18.5469H6.28848H15.7115Z",
    fill: "#F13538",
    stroke: "#F13538"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutlined);
export default __webpack_public_path__ + "static/media/DeleteOutlined.bf5d39bed272c72142a4e28d12286073.svg";
export { ForwardRef as ReactComponent };